export default __webpack_public_path__ + "static/IBMPlexSans-SemiBold-Latin2-79bc83792898f002dfc0717bb351174d.woff";